import { User } from "@app/shared/models";
import { SampleBoardValidateItem } from "@app/strain/sample-boards/models/validate/sample-board-validate-item.model";

export enum SampleBoardValidateRequestStatus {
    New = 1,
    Done = 2,
}
export class SampleBoardValidateRequest {
    id: number;
    createdAt: string;
    createdBy: User;
    status: SampleBoardValidateRequestStatus;
    items?: SampleBoardValidateItem[];

    constructor(entry: any = {}) {
        this.id = entry?.id;
        this.createdAt = entry?.createdAt;
        this.createdBy = entry?.createdBy ? new User(entry.createdBy) : null;
        this.status = entry?.status;
        this.items = entry?.items ? entry.items.map(
            (ntry) => new SampleBoardValidateItem(ntry)) : [];
    }
}
